






import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IPolicy } from 'admiral-core';
import { mixins } from 'vue-class-component';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'policy-product-short',
  components: { PolicyStatusBadge },
})
export default class PolicyProductShort extends mixins(BaseMixin) {
  @Prop({ type: Object, required: true })
  policy!: IPolicy;

  @Prop({ type: Boolean, required: false, default: true })
  small!: boolean;

  get productName(): string {
    return this.policy?.product?.name ? this.policy.product.name : 'Kein Produkt';
  }
}
